import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { MSpinner, MSelect } from "components/Shared";
import DialogContainer from "react-md/lib/Dialogs";
import { Cell, Button, TextField  } from "react-md";
import { connect } from "react-redux";
import responseHandler from "responseHandler";
import { sendCaseToUser, getSchedulingAssistants } from "requests/schedulingAssistant";

const SendCaseToUserQueue = props => {
  const mounted = useRef(true);
  const [schedulingUsersForAssign, setSchedulingUsersForAssign] = useState([]);
  const [schedulingUserToAssign, setSchedulingUserToAssign] = useState(null);  
  const [showEscalatingDialog, setShowEscalatingDialog] = useState(false);
  const [sendCaseNote, setSendCaseNote] = useState(null);
  const [escalating, setEscalating] = useState(false);

  useEffect(() => {
    getSchedulingAssistants((users) => mapSchedulingUsersForAssign(users), mounted);  
    return () => {
      mounted.current = false;
    };
  }, []);

  const mapSchedulingUsersForAssign = (users) => {
    let availUsers = users.map(user => {
      return { value: user.internetUserId, label: user.firstLastName };
    });
    setSchedulingUsersForAssign(availUsers);
  };

  const sendCaseToSchedulingUser = () => {
    setShowEscalatingDialog(false);
    setEscalating(true);
    sendCaseToUser({
      ControlIdNumber: props.controlNumber,
      Notes: sendCaseNote,
      AssignToInternetUserId: schedulingUserToAssign,
      TimeLog: null,
    }, () => {
      setEscalating(false);
      setSchedulingUserToAssign(null);
      props.makeSuccessToast("User Successfully Assigned");
    }, () => {
      setEscalating(false);
      setSchedulingUserToAssign(null);
      props.makeWarningToast("Unable to Assign User");
    }, mounted);
  };

  const sendToSchedulingUserCaseActions = [
    <Button
      className="m-t-10"
      key="continue"
      raised
      primary
      disabled={schedulingUserToAssign === null
        || (sendCaseNote === null || sendCaseNote === "")}
      onClick={() => sendCaseToSchedulingUser()}
    >
      Continue
    </Button>,
    <Button
      className="m-t-10"
      key="cancel"
      raised
      primary
      onClick={() => {
        setShowEscalatingDialog(false);
        setSchedulingUserToAssign(null);
      }}
    >
      Cancel
    </Button>
  ];  

  return (
    <>
      <Cell size={12}>
        <Button
          style={{width: "-webkit-fill-available"}}            
          key="send-to-user-queue"
          raised
          primary
          disabled={escalating}
          onClick={() => setShowEscalatingDialog(true)}>
          Send to User's Queue
        </Button>
      </Cell>
      <div id="send-to-manager-container">
        <DialogContainer
          id="dialog-send-to-manager"
          className="dialog-send-to-manager"
          visible={showEscalatingDialog}
          title={"Send to User"}
          modal
          width={500}
          actions={sendToSchedulingUserCaseActions}>
          <MSelect
            id="selectManager"
            placeholder={"Please select a user..."}
            options={schedulingUsersForAssign}
            onChange={option => option ? setSchedulingUserToAssign(option.value) : setSchedulingUserToAssign(null)}
            name={"User:"}
            className="md-full-width"
            getMenuPortalTarget={() => document.querySelector(".dialog-send-to-manager")}
          />
          <TextField
            id="dialog-send-case-note"
            type={"text"}
            maxLength={1000}
            label={"Note"}
            onChange={val => setSendCaseNote(val)}
            required={true}
            rows={3}
          />           
        </DialogContainer>
        <DialogContainer
          id="dialog-sending-to-manager"
          visible={escalating}
          modal
          title={"Sending Case to User..."}
          focusOnMount={false}
          width={400}>
          <MSpinner />
        </DialogContainer>
      </div>        
    </>);
};

SendCaseToUserQueue.propTypes = {
  controlNumber: PropTypes.number.isRequired,  
  makeSuccessToast: PropTypes.func,
  makeWarningToast: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  makeSuccessToast(text) {
    responseHandler.customToast(text, "success", dispatch);
  },
  makeWarningToast(text) {
    responseHandler.customToast(text, "warning", dispatch);
  },
});

export default connect(null, mapDispatchToProps)(SendCaseToUserQueue);
